module.exports = __webpack_public_path__ + "img/card_header_help_control.210aa74e.jpg";